module.exports = __webpack_public_path__ + "img/calcul-litteral1.6536a94b.png";